import React, { useEffect, useRef, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabPanel from "@mui/lab/TabPanel";
import { TabContext } from "@mui/lab";
import { IconButton, TextField } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ClearIcon from "@mui/icons-material/Clear";
import "./Section.css";
import SuccessAlert from "../components/success-alert/SuccessAlert";
import ErrorAlert from "../components/error-alert/ErrorAlert";
import useLanguages from "../hooks/useLanguages";
import { API, SERVER_DOMAIN } from "../assets/staticData";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import { toast } from "react-toastify";
import TextEditor from "../components/rich-text/TextEditor/TextEditor";
import { CACHE_KEY } from "../constant/cache-key";
import ClearCacheButton from "../components/ClearCacheButton/ClearCacheButton";

export default function AboutUs({ user }) {
  const langs = useLanguages();

  const [value, setValue] = useState("0");
  const [data, setData] = useState([]);
  const [offices, setOffices] = useState([]);
  const [slides, setSlides] = useState([]);
  const [images, setImages] = useState([]);
  const [success, setSuccess] = useState(false);
  const [fail, setFail] = useState(false);
  const [loading, setLoading] = useState(true);
  const [whereWasClicked, setWhereWasClicked] = useState({});
  const hiddenFileInput = useRef();
  const hiddenFileInput2 = useRef();
  const hiddenFileInput3 = useRef();
  const hiddenFileInput4 = useRef();

  let userToken = localStorage.getItem("userToken");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  let tabStyle = { textTransform: "capitalize", fontWeight: "500" };

  // Get Data from backend
  useEffect(() => {
    let docs = langs.map((item) => ({
      aboutUs: "",
      cardsHeading: "",
      officesHeading: "",
      slideBTNText: "",
      slideBTNLink: "",
      cards: [
        {
          text: "",
          linkText: "",
          link: "",
        },
        {
          text: "",
          linkText: "",
          link: "",
        },
        {
          text: "",
          linkText: "",
          link: "",
        },
      ],
      language: item.attributes.language,
    }));
    setData(docs);

    let officesDocs = langs.map((item) => []);
    setOffices(officesDocs);
    let slidesDocs = langs.map((item) => []);
    setSlides(slidesDocs);
    let imagesDocs = langs.map((item) => ({
      headerImg: "",
      headerImgM: "",
      historyImg: "",
      historyBadge: "",
      language: item.attributes.language,
    }));
    setImages(imagesDocs);
    async function getData() {
      await fetch(`${API}/about-us`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      }).then(async (res) => {
        const response = await res.json();
        const apiData = response.data?.attributes?.aboutData || [];

        setData((prevData) => {
          return prevData.map((localItem) => {
            const apiItem = apiData.find(
              (apiItem) => apiItem.language === localItem.language
            );

            if (apiItem) {
              return {
                ...localItem,

                aboutUs: apiItem.aboutUs || localItem.aboutUs,

                cardsHeading: apiItem.cardsHeading || localItem.cardsHeading,
                cards: apiItem.cards || localItem.cards,
                officesHeading:
                  apiItem.officesHeading || localItem.officesHeading,
                slideBTNText: apiItem.slideBTNText || localItem.slideBTNText,
                slideBTNLink: apiItem.slideBTNLink || localItem.slideBTNLink,
              };
            } else {
              return localItem;
            }
          });
        });

        const updatedOffices = apiData.map((item) => item.offices || []);

        setOffices(updatedOffices);

        const updatedSlides = apiData.map((item) => item.slides || []);

        setSlides(updatedSlides);

        const apiImages = response.data?.attributes?.images || [];

        setImages((prevData) => {
          return prevData.map((localItem) => {
            const apiItem = apiImages.find(
              (apiItem) => apiItem.language === localItem.language
            );

            if (apiItem) {
              return {
                ...localItem,
                headerImg: apiItem.headerImg || localItem.headerImg,
                headerImgM: apiItem.headerImgM || localItem.headerImgM,
                historyImg: apiItem.historyImg || localItem.historyImg,
                historyBadge: apiItem.historyBadge || localItem.historyImg,
              };
            } else {
              return localItem;
            }
          });
        });

        setLoading(false);
      });
    }

    getData();
  }, [langs]);

  const submitData = (item, index) => {
    let updatedData = [...data];

    offices.forEach((officeArray, index) => {
      if (updatedData[index]) {
        updatedData[index].offices = officeArray;
      } else {
        updatedData[index] = { offices: officeArray };
      }
    });

    slides.forEach((slideArray, index) => {
      if (updatedData[index]) {
        updatedData[index].slides = slideArray;
      } else {
        updatedData[index] = { slides: slideArray };
      }
    });

    fetch(`${API}/about-us`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({
        data: { aboutData: data },
      }),
    }).then(async (res) => {
      if (res.ok) {
        setSuccess(true);
        setData(updatedData);
      } else {
        setFail(true);
      }
    });
  };

  const handleAddImage = (e) => {
    const formData = new FormData();
    const file = e.target.files[0];

    if (file) {
      formData.append("files", file);

      fetch(`${API}/upload`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
        body: formData,
      }).then(async (res) => {
        const response = await res.json();
        const iconURL = response[0]?.url;

        let updatedOffices = [...offices];

        let imagesArray =
          updatedOffices[whereWasClicked.index][whereWasClicked.idx].images;

        imagesArray.splice(imagesArray.length - 1, 0, iconURL);

        setOffices(updatedOffices);
        if (hiddenFileInput.current) {
          hiddenFileInput.current.value = "";
        }
      });
    }
  };

  const handleRemoveOfficeItem = (index, idx) => {
    let updatedOffices = [...offices];

    updatedOffices[index] = updatedOffices[index].filter((_, i) => i !== idx);

    setOffices(updatedOffices);
  };

  const handleRemoveSlide = (index, idx) => {
    let updatedSlides = [...slides];

    updatedSlides[index] = updatedSlides[index].filter((_, i) => i !== idx);

    setSlides(updatedSlides);
  };

  const handleRemoveOffice = (index, idx, imageIndex) => {
    let updatedOffices = [...offices];

    updatedOffices[index][idx].images = updatedOffices[index][
      idx
    ].images.filter((_, i) => i !== imageIndex);

    setOffices(updatedOffices);
  };

  const handleInputChange = (e, index, idx) => {
    const { name, value } = e.target;

    let updatedOffices = [...offices];
    updatedOffices[index][idx] = {
      ...updatedOffices[index][idx],
      [name]: value,
    };

    setOffices(updatedOffices);
  };

  const handleSlidesInputChange = (e, index, idx) => {
    const { name, value } = e.target;

    let updatedSlided = [...slides];
    updatedSlided[index][idx] = {
      ...updatedSlided[index][idx],
      [name]: value,
    };

    setSlides(updatedSlided);
  };

  const handleImageChange = (e, index, type) => {
    const formData = new FormData();
    const file = e.target.files[0];

    if (file) {
      formData.append("files", file);

      fetch(`${API}/upload`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
        body: formData,
      }).then(async (res) => {
        const response = await res.json();
        const iconURL = response[0]?.url;

        let updatedImages = [...images];

        updatedImages[index] = { ...updatedImages[index], [type]: iconURL };

        fetch(`${API}/about-us`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken}`,
          },
          body: JSON.stringify({
            data: { images: updatedImages },
          }),
        }).then((res) => {
          if (res.ok) {
            setImages(updatedImages);
            toast("Updated Successfully", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              type: "success",
            });
          }
        });
      });
    }
  };

  return (
    <TabContext value={value}>
      <Box sx={{ width: "100%" }}>
        <h3 style={{ textTransform: "capitalize" }}>About Us Settings</h3>

        <Box mt={2}>
          <ClearCacheButton
            keys={[
              CACHE_KEY.aboutUs
            ]} />
        </Box>

        <Tabs
          value={value}
          onChange={handleChange}
          textColor="secondary"
          indicatorColor="secondary"
          aria-label="secondary tabs"
        >
          {langs?.map((item, index) => {
            return (
              <Tab
                key={index}
                sx={tabStyle}
                value={index.toString()}
                label={item.attributes.language}
                icon={
                  <img
                    src={
                      SERVER_DOMAIN + item.attributes.icon.data.attributes.url
                    }
                    style={{ width: 25, aspectRatio: 1, borderRadius: 20 }}
                  />
                }
                iconPosition="start"
              />
            );
          })}
        </Tabs>

        {loading ? (
          <></>
        ) : (
          <>
            {langs?.map((item, index) => {
              return (
                <TabPanel value={index.toString()} key={index}>
                  <SuccessAlert show={success} setShow={(v) => setSuccess(v)} />
                  <ErrorAlert show={fail} setShow={(v) => setFail(v)} />
                  <div
                    style={{
                      pointerEvents: user.perms[8].edit ? null : "none",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 20,
                      }}
                    >
                      <div>
                        <p style={{ fontSize: 15 }}>
                          Description in the About Us page
                        </p>

                        <div style={{ margin: "20px 0" }}>
                          <TextEditor
                            value={data[index]?.aboutUs || ""}
                            onChange={(v) => {
                              setData([
                                ...data.map((item, idx) => {
                                  if (idx === index) {
                                    return {
                                      ...item,
                                      aboutUs: v,
                                    };
                                  } else {
                                    return item;
                                  }
                                }),
                              ]);
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="divider"></div>

                    <div className="mt-6">
                      <h3 className="text-[2rem]">How we became #1</h3>

                      <TextField
                        label="Heading"
                        sx={{ width: 300, marginY: 1 }}
                        value={data[index]?.cardsHeading || ""}
                        onChange={(e) => {
                          setData([
                            ...data.map((item, idx) => {
                              if (idx === index) {
                                return {
                                  ...item,
                                  cardsHeading: e.target.value,
                                };
                              } else {
                                return item;
                              }
                            }),
                          ]);
                        }}
                      />

                      <div className="mt-5 grid lg:grid-cols-2 grid-cols-1 ">
                        {[...Array(3)].map((item, idx) => (
                          <div key={idx} className="w-1/2 mt-5">
                            <h3>Card {idx + 1}</h3>
                            <TextField
                              sx={{ width: 300, mt: 1 }}
                              label="Text"
                              variant="outlined"
                              size="small"
                              multiline
                              rows={7}
                              value={data[index]?.cards[idx]?.text || ""}
                              onChange={(e) => {
                                setData((prevData) =>
                                  prevData.map((item, i) => {
                                    if (i === index) {
                                      return {
                                        ...item,
                                        cards: item.cards.map((card, j) => {
                                          if (j === idx) {
                                            return {
                                              ...card,
                                              text: e.target.value,
                                            };
                                          }
                                          return card;
                                        }),
                                      };
                                    }
                                    return item;
                                  })
                                );
                              }}
                            />

                            <TextField
                              sx={{ width: 300, mt: 2 }}
                              label="Link Text"
                              variant="outlined"
                              size="small"
                              value={data[index]?.cards[idx]?.linkText || ""}
                              onChange={(e) => {
                                setData((prevData) =>
                                  prevData.map((item, i) => {
                                    if (i === index) {
                                      return {
                                        ...item,
                                        cards: item.cards.map((card, j) => {
                                          if (j === idx) {
                                            return {
                                              ...card,
                                              linkText: e.target.value,
                                            };
                                          }
                                          return card;
                                        }),
                                      };
                                    }
                                    return item;
                                  })
                                );
                              }}
                            />
                            <TextField
                              sx={{ width: 300, mt: 2 }}
                              label="Link"
                              variant="outlined"
                              size="small"
                              value={data[index]?.cards[idx]?.link || ""}
                              onChange={(e) => {
                                setData((prevData) =>
                                  prevData.map((item, i) => {
                                    if (i === index) {
                                      return {
                                        ...item,
                                        cards: item.cards.map((card, j) => {
                                          if (j === idx) {
                                            return {
                                              ...card,
                                              link: e.target.value,
                                            };
                                          }
                                          return card;
                                        }),
                                      };
                                    }
                                    return item;
                                  })
                                );
                              }}
                            />
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="divider"></div>

                    <div className="mt-6">
                      <h3 className="text-[2rem]">Offices</h3>

                      <TextField
                        label="Heading"
                        sx={{ width: 300, marginY: 1 }}
                        value={data[index]?.officesHeading || ""}
                        onChange={(e) => {
                          setData([
                            ...data.map((item, idx) => {
                              if (idx === index) {
                                return {
                                  ...item,
                                  officesHeading: e.target.value,
                                };
                              } else {
                                return item;
                              }
                            }),
                          ]);
                        }}
                      />

                      <div className="mt-5 grid lg:grid-cols-2 grid-cols-1 ">
                        {offices[index]?.map((item, idx) => (
                          <div key={idx} className="relative mt-4">
                            <div
                              className="flex w-9/12"
                              style={{ justifyContent: "space-between" }}
                            >
                              <h3>Office {idx + 1}</h3>

                              <IconButton
                                onClick={() =>
                                  handleRemoveOfficeItem(index, idx)
                                }
                              >
                                <ClearIcon sx={{ color: "red" }} />
                              </IconButton>
                            </div>
                            <TextField
                              sx={{ width: 350, mt: 1 }}
                              label="Label"
                              variant="outlined"
                              size="small"
                              name="label"
                              value={offices[index][idx]?.label || ""}
                              onChange={(e) => handleInputChange(e, index, idx)}
                            />

                            <TextField
                              sx={{ width: 350, mt: 2 }}
                              label="Phone"
                              variant="outlined"
                              size="small"
                              name="phone"
                              value={offices[index][idx]?.phone || ""}
                              onChange={(e) => handleInputChange(e, index, idx)}
                            />
                            <TextField
                              sx={{ width: 350, mt: 2 }}
                              label="Address"
                              variant="outlined"
                              size="small"
                              name="address"
                              value={offices[index][idx]?.address || ""}
                              onChange={(e) => handleInputChange(e, index, idx)}
                            />
                            <TextField
                              sx={{ width: 350, mt: 2 }}
                              label="Lat"
                              variant="outlined"
                              size="small"
                              name="lat"
                              value={offices[index][idx]?.lat || ""}
                              onChange={(e) => handleInputChange(e, index, idx)}
                            />
                            <TextField
                              sx={{ width: 350, mt: 2 }}
                              label="Long"
                              variant="outlined"
                              size="small"
                              name="long"
                              value={offices[index][idx]?.long || ""}
                              onChange={(e) => handleInputChange(e, index, idx)}
                            />

                            <div
                              className="mt-4 flex gap-5 w-full flex-wrap "
                              style={{ justifyContent: "flex-start" }}
                            >
                              {offices[index][idx]?.images?.length > 0 &&
                                offices[index][idx].images.map(
                                  (item, imageIndex) => (
                                    <div key={imageIndex}>
                                      {imageIndex ===
                                        offices[index][idx].images.length - 1 ? (
                                        <div
                                          className="w-20 h-20 border-dashed border-2 border-gray-300 flex rounded-md cursor-pointer"
                                          onClick={() => {
                                            setWhereWasClicked({ index, idx });
                                            hiddenFileInput.current.click();
                                          }}
                                        >
                                          <AddCircleOutlineIcon className="text-gray-400" />
                                        </div>
                                      ) : (
                                        <div
                                          className="relative w-20 h-20 rounded-md overflow-hidden cursor-pointer"
                                          onClick={() =>
                                            handleRemoveOffice(
                                              index,
                                              idx,
                                              imageIndex
                                            )
                                          }
                                        >
                                          <img
                                            className="w-full h-full object-cover"
                                            src={
                                              item instanceof File
                                                ? URL.createObjectURL(item)
                                                : `${SERVER_DOMAIN}${item}`
                                            }
                                          />
                                          <div className="group absolute top-0 left-0 w-full h-full bg-black bg-opacity-0 hover:bg-opacity-30 transition-opacity flex items-center justify-center">
                                            <ClearIcon className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  )
                                )}
                            </div>
                          </div>
                        ))}
                      </div>

                      <div
                        className="w-3/12 h-9 rounded-sm flex bg-green-600 text-white mt-3 cursor-pointer hover:bg-green-700 transition-all delay-100"
                        onClick={() => {
                          let officesDocs = [...offices];
                          officesDocs[index].push({
                            images: [""],
                            lat: "",
                            long: "",
                            label: "",
                            phone: "",
                            address: "",
                          });
                          setOffices(officesDocs);
                        }}
                      >
                        Add a New Office
                      </div>
                      <input
                        type="file"
                        accept="image/png, image/jpeg"
                        onChange={handleAddImage}
                        ref={hiddenFileInput}
                        style={{ display: "none" }}
                      />
                    </div>

                    <div className="divider"></div>

                    <div className="mt-6">
                      <h3 className="text-[2rem] mb-3">
                        Why Choose Us Cards For Slider
                      </h3>

                      <TextField
                        label="Button Text"
                        sx={{ width: 300, margin: 1 }}
                        value={data[index]?.slideBTNText || ""}
                        onChange={(e) => {
                          setData([
                            ...data.map((item, idx) => {
                              if (idx === index) {
                                return {
                                  ...item,
                                  slideBTNText: e.target.value,
                                };
                              } else {
                                return item;
                              }
                            }),
                          ]);
                        }}
                      />
                      <TextField
                        label="Button Link"
                        sx={{ width: 300, margin: 1 }}
                        value={data[index]?.slideBTNLink || ""}
                        onChange={(e) => {
                          setData([
                            ...data.map((item, idx) => {
                              if (idx === index) {
                                return {
                                  ...item,
                                  slideBTNLink: e.target.value,
                                };
                              } else {
                                return item;
                              }
                            }),
                          ]);
                        }}
                      />

                      <div className="mt-5 grid lg:grid-cols-2 grid-cols-1 ">
                        {slides[index]?.map((item, idx) => (
                          <div key={idx} className=" mt-4">
                            <div
                              className="flex w-9/12"
                              style={{ justifyContent: "space-between" }}
                            >
                              <h3>Slide Card {idx + 1}</h3>

                              <IconButton
                                onClick={() => handleRemoveSlide(index, idx)}
                              >
                                <ClearIcon sx={{ color: "red" }} />
                              </IconButton>
                            </div>
                            <TextField
                              sx={{ width: 350, mt: 1 }}
                              label="Title"
                              variant="outlined"
                              size="small"
                              name="title"
                              value={slides[index][idx]?.title || ""}
                              onChange={(e) =>
                                handleSlidesInputChange(e, index, idx)
                              }
                            />

                            <TextField
                              sx={{ width: 350, mt: 2 }}
                              label="Description"
                              variant="outlined"
                              size="small"
                              name="desc"
                              multiline
                              rows={3}
                              value={slides[index][idx]?.desc || ""}
                              onChange={(e) =>
                                handleSlidesInputChange(e, index, idx)
                              }
                            />
                            <TextField
                              sx={{ width: 350, mt: 2 }}
                              label="Link"
                              variant="outlined"
                              size="small"
                              name="link"
                              value={slides[index][idx]?.link || ""}
                              onChange={(e) =>
                                handleSlidesInputChange(e, index, idx)
                              }
                            />
                          </div>
                        ))}
                      </div>

                      <div
                        className="w-3/12 h-9 rounded-sm flex bg-green-600 text-white mt-3 cursor-pointer hover:bg-green-700 transition-all delay-100"
                        onClick={() => {
                          let slidesDocs = [...slides];
                          slidesDocs[index].push({
                            title: "",
                            desc: "",
                            link: "",
                          });
                          setSlides(slidesDocs);
                        }}
                      >
                        Add a New Slide
                      </div>
                    </div>

                    {user.perms[8].edit && (
                      <div
                        className="submitBTN"
                        onClick={() => submitData(item, index)}
                      >
                        Save Changes
                      </div>
                    )}

                    <div className="divider"></div>

                    {user.perms[8].edit && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          gap: 15,
                          flexWrap: "wrap",
                        }}
                      >
                        <div className="w-4/12">
                          <h3 className="ml-3">Header Image</h3>

                          <div
                            className="group relative w-full h-[220px] mt-4 rounded-[15px] overflow-hidden cursor-pointer "
                            onClick={() => hiddenFileInput2.current.click()}
                          >
                            <img
                              style={{
                                width: "100%",
                                aspectRatio: 1,
                                objectFit: "cover",
                                transition: "0.2s",
                              }}
                              src={
                                images[index]?.headerImg
                                  ? SERVER_DOMAIN + images[index]?.headerImg
                                  : require("../assets/placeholder-image.png")
                              }
                            />

                            <div className="group absolute top-0 left-0 w-full rounded-[15px] h-full bg-black bg-opacity-0 hover:bg-opacity-30 transition-opacity flex items-center justify-center">
                              <CameraAltIcon
                                style={{ fontSize: 45 }}
                                className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                              />
                            </div>

                            <input
                              type="file"
                              accept="image/png, image/jpeg"
                              onChange={(e) =>
                                handleImageChange(e, index, "headerImg")
                              }
                              ref={hiddenFileInput2}
                              style={{ display: "none" }}
                            />
                          </div>
                        </div>
                        <div className="w-3/12">
                          <h3 className="ml-3">Mobile Header Image</h3>

                          <div
                            className="group relative w-full h-[220px] mt-4 rounded-[15px] overflow-hidden cursor-pointer "
                            onClick={() => hiddenFileInput2.current.click()}
                          >
                            <img
                              style={{
                                width: "100%",
                                aspectRatio: 1,
                                objectFit: "cover",
                                transition: "0.2s",
                              }}
                              src={
                                images[index]?.headerImgM
                                  ? SERVER_DOMAIN + images[index]?.headerImgM
                                  : require("../assets/placeholder-image.png")
                              }
                            />

                            <div className="group absolute top-0 left-0 w-full rounded-[15px] h-full bg-black bg-opacity-0 hover:bg-opacity-30 transition-opacity flex items-center justify-center">
                              <CameraAltIcon
                                style={{ fontSize: 45 }}
                                className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                              />
                            </div>

                            <input
                              type="file"
                              accept="image/png, image/jpeg"
                              onChange={(e) =>
                                handleImageChange(e, index, "headerImgM")
                              }
                              ref={hiddenFileInput2}
                              style={{ display: "none" }}
                            />
                          </div>
                        </div>

                        <div className="w-3/12">
                          <h3 className="ml-3">History Image</h3>

                          <div
                            className="group relative w-full mt-4 rounded-[15px] overflow-hidden cursor-pointer "
                            onClick={() => hiddenFileInput3.current.click()}
                          >
                            <img
                              style={{
                                width: "100%",
                                aspectRatio: 1,
                                objectFit: "cover",
                                transition: "0.2s",
                              }}
                              src={
                                images[index]?.historyImg
                                  ? SERVER_DOMAIN + images[index]?.historyImg
                                  : require("../assets/placeholder-image.png")
                              }
                            />

                            <div className="group absolute top-0 left-0 w-full rounded-[15px] h-full bg-black bg-opacity-0 hover:bg-opacity-30 transition-opacity flex items-center justify-center">
                              <CameraAltIcon
                                style={{ fontSize: 45 }}
                                className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                              />
                            </div>

                            <input
                              type="file"
                              accept="image/png, image/jpeg"
                              onChange={(e) =>
                                handleImageChange(e, index, "historyImg")
                              }
                              ref={hiddenFileInput3}
                              style={{ display: "none" }}
                            />
                          </div>
                        </div>

                        <div className="w-3/12">
                          <h3 className="ml-3">History Badge</h3>

                          <div
                            className="group relative w-full mt-4 rounded-[15px] overflow-hidden cursor-pointer "
                            onClick={() => hiddenFileInput4.current.click()}
                          >
                            <img
                              style={{
                                width: "100%",
                                aspectRatio: 1,
                                objectFit: "cover",
                                transition: "0.2s",
                              }}
                              src={
                                images[index]?.historyBadge
                                  ? SERVER_DOMAIN + images[index]?.historyBadge
                                  : require("../assets/placeholder-image.png")
                              }
                            />

                            <div className="group absolute top-0 left-0 w-full rounded-[15px] h-full bg-black bg-opacity-0 hover:bg-opacity-30 transition-opacity flex items-center justify-center">
                              <CameraAltIcon
                                style={{ fontSize: 45 }}
                                className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                              />
                            </div>

                            <input
                              type="file"
                              accept="image/png, image/jpeg"
                              onChange={(e) =>
                                handleImageChange(e, index, "historyBadge")
                              }
                              ref={hiddenFileInput4}
                              style={{ display: "none" }}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </TabPanel>
              );
            })}
          </>
        )}
      </Box>
    </TabContext>
  );
}
